export enum PromotionEnum {
    RegularRate = '1',
    Promotion_SpecialRate = '2',
    CorporateRate = '3',
    AgencyRate = '4',
    GovernmentMilitaryRate = '401',
    SeniorCitizenRate = '402',
    CAA_AAA_Rate = '403'
}